import { request } from './client';

export const notificationsApi = {
  list:    () => request('/notifications'),
  summary: () => request('/notifications/summary'),
  read:    (id) => request(`/notifications/${id}/read`, { method: 'PATCH' }),
  readAll: () => request('/notifications/read-all', { method: 'PATCH' }),
  // Web push — VAPID public key for the SW subscription dance. The
  // server returns an empty string when web push isn't configured,
  // which the webPush util treats as "not available on this server".
  vapidPublicKey: () => request('/notifications/vapid-public-key')
};
